import Axios from "axios";
import ApiUtils from "../utils/api_utils";
import { PointSummaryDM } from "../data_model/point_summary_dm";
import { StarSummaryDM } from "../data_model/star_summary_dm";

const FinanceSM = {
  state: {
    pointSummaryData: new PointSummaryDM({}),
    starSummaryData: new StarSummaryDM({}),
    pointInfo: {},
    starInfo: {},
  },
  reducers: {
    setFinanceState(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getStarSummary(payload, rootState) {
      let result;
      await Axios.get(
        `https://${ApiUtils.authority}/finance/api/star_transactions/stars_summary/`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          const data = StarSummaryDM.fromJson(response.data);
          dispatch.FinanceSM.setFinanceState({
            ...rootState.FinanceSM,
            starSummaryData: data,
          });
          result = {
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async getPointSummary(payload, rootState) {
      let result;
      await Axios.get(
        `https://${ApiUtils.authority}/finance/api/transactions/points_summary/`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {
          const data = PointSummaryDM.fromJson(response.data);
          dispatch.FinanceSM.setFinanceState({
            ...rootState.FinanceSM,
            pointSummaryData: data,
          });
          result = {
            status: 200,
            message: "success",
          };
        })
        .catch(function (error) {
          result = {
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async getPointCategory(payload, rootState) {
      await Axios.get(
        `https://${ApiUtils.authority}/finance/api/point_categories/ `,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then(function (response) {})
        .catch(function (error) {});
    },
    /**
     * Get Star History
     * payload => {date = '2022-01-31'}
     */
    async getStarHistory(payload, rootState) {
      return Axios.get(
        `https://${ApiUtils.authority}/finance/api/star_transactions/monthly/`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
          params: payload,
        }
      );
    },
    /**
     * Get Star History
     * payload => {date = '2022-01-31'}
     */
    async getPointHistory({ date }, rootState) {
      return Axios.get(
        `https://${ApiUtils.authority}/finance/api/transactions/monthly/`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
          params: {
            date: date,
          },
        }
      );
    },

    async initHome(payload, rootState) {
      let endpoints = [
        `https://${ApiUtils.authority}/finance/api/star_transactions/stars_summary/`,
        `https://${ApiUtils.authority}/finance/api/transactions/points_summary/`,
      ];

      Promise.all(
        endpoints.map((endpoint) =>
          Axios.get(endpoint, {
            headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
            withCredentials: false,
          })
        )
      ).then(([{ data: star }, { data: point }]) => {
        dispatch.FinanceSM.setFinanceState({
          ...rootState.FinanceSM,
          pointSummaryData: PointSummaryDM.fromJson(point),
          starSummaryData: StarSummaryDM.fromJson(star),
        });
      });
    },

    async initInfo(payload, rootState) {
      let endpoints = [
        `https://${ApiUtils.authority}/org_info/api/info/notice_point/`,
        `https://${ApiUtils.authority}/org_info/api/info/notice_star/`,
      ];

      Promise.all(
        endpoints.map((endpoint) =>
          Axios.get(endpoint, {
            headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
            withCredentials: false,
          })
        )
      ).then(([{ data: pointInfo }, { data: starInfo }]) => {
        dispatch.FinanceSM.setFinanceState({
          ...rootState.FinanceSM,
          pointInfo: pointInfo,
          starInfo: starInfo,
        });
      });
    },

    /**
     * update user profile
     */
    async getTotal(payload, rootState) {
      return Axios.get(
        `https://${ApiUtils.authority}/finance/api/total-earned/`,
        {
          headers: ApiUtils.getHeaderMultipart({
            token: rootState.LoginSM.token,
          }),
          withCredentials: false,
        }
      );
    },
  }),
};

export default FinanceSM;
